<template>
	<v-layout row wrap class="form-step-two">
		<v-flex 
			xs12 
			class="form-step-two-container"
			:class="[ isQinti ? 'back-qinti' : isLucky ? 'backL' : 'primary']">
			<v-layout row wrap align-center class="form-step-two-header">
				<v-btn
					v-if="!isForm"
					class="form-btn-close"
					depressed
					flat
					icon
					@click="$emit('close-form')"
				>
					<v-icon color="white">close</v-icon>
				</v-btn>
				<v-flex class="form-img">
					<img
						src="/static/images-new/logos/logo-banner.svg"
						alt="logo qinti"
						height="44"
						v-if="isQinti"
					/>
					<img
						src="/static/images-new/logos/logo-banner-lucky.png"
						alt="logo lucky"
						height="30"
						v-else-if="isLucky"
					/>
					<img
						src="/static/images-new/logos/logo-casamarket-orange-mini.svg"
						alt="logo casamarket"
						height="44"
						v-else
					/>
				</v-flex>
				<v-flex xs12 text-left>
					<h2 class="white--text w-black form-step-two-title">
						Regístrate y vende <br/>CON NOSOTROS
					</h2>
				</v-flex>
			</v-layout>
		</v-flex>
		<v-flex xs12 newbackground>
			<form-simulator
				:code-phone="codePhone"
				:document-selected="documentSelected"
				:document-types="documentTypes"
				:document-validation="documentValidation"
				:email-validation="emailValidation"
				:form="form"
				:items="items"
				:validated="validated"
				:phone-invalid="phoneInvalid"
				:phone-message="phoneMessage"
				:validation-message="validationMessage"
				:list-plans="listPlans"
				@get-data="$emit('get-data', $event)"
				@valid-phone="$emit('valid-phone')"
			></form-simulator>
		</v-flex>
	</v-layout>
</template>

<script>
	import formSimulator from '@/components/simulator/form-simulator';

	function isQinti() {
		if (this.$route.query.project) {
			return this.$route.query.project === 'QINTI';
		}
		return false;
	}

	function isLucky() {
		if (this.$route.query.project) {
			return this.$route.query.project === 'LUCKY';
		}
		return false;
	}

	export default {
		name: 'form-step-two',
		components: {
			formSimulator,
		},
		computed: {
			isQinti,
			isLucky,
		},
		props: {
			codePhone: String,
			documentSelected: {
				default: () => {},
				type: Object,
			},
			documentTypes: {
				default: () => [],
				type: Array,
			},
			documentValidation: {
				default: true,
				type: Boolean,
			},
			emailValidation: {
				default: false,
				type: Boolean,
			},
			form: {
				default: () => {},
				type: Object,
			},
			items: {
				default: () => [],
				type: Array,
			},
			phoneInvalid: {
				default: true,
				type: Boolean,
			},
			phoneMessage: String,
			validated: {
				default: false,
				type: Boolean,
			},
			validationMessage: String,
			listPlans: {
				default: () => [],
				type: Array,
			},
		},
	};
</script>

<style lang="scss" scoped>
	.form-step-two {
		height: 91%;
		left: 17px;
		position: absolute;
		top: 19px;
		width: 91%;

		&-title {
			font-size: size(large27);
			letter-spacing: normal;
			line-height: normal;
			padding-top: 12px;
			text-align: center;

			@media (min-width: 936px) {
				padding-top: 0px;
			}
		}
		
		&-header {
			padding: 50px 0px 20px;
			position: relative;

			@media (min-width: 936px) {
				padding: 50px 0px 30px;
			}

			.form-btn-close {
				top: 10px;
			}

			.form-img {
				left: 15px;
				position: absolute;
				top: 12px;
			}
		}

		&-container {
			&:before {
				background-color: #02979b;
				content: '';
				height: 12px;
				left: 0;
				position: absolute;
				top: 142px;
				transform: skew(0deg, -1.5deg);
				width: 100%;
				z-index: 2;

				@media (min-width: 936px) {
					top: 140px;
					z-index: 0;
				}
			}

			&.back-qinti {
				&:before {
					background-color: #e4278e;
					content: '';
					height: 12px;
					left: 0;
					position: absolute;
					top: 142px;
					transform: skew(0deg, -1.5deg);
					width: 100%;
					z-index: 2;

					@media (min-width: 936px) {
						top: 140px;
						z-index: 0;
					}
				}
			}

			&.backL{
				&:before {
					background-color: map-get($colors, back-l);
					content: '';
					height: 12px;
					left: 0;
					position: absolute;
					top: 142px;
					transform: skew(0deg, -1.5deg);
					width: 100%;
					z-index: 2;

					@media (min-width: 936px) {
						top: 140px;
						z-index: 0;
					}
				}
			}
		}
	}

	.show-form {
		.form-step-two {
			height: 100%;
			left: 0px;
			top: 0px;
			width: 100%;
		}
	}

	.back-qinti {
		background-color: #e4278e;
	}
</style>


// WEBPACK FOOTER //
// src/components/simulator/form-step-two.vue